import { combineReducers, configureStore } from "@reduxjs/toolkit";

import authReducer from "./authentication/slices/auth";
import messageReducer from "./authentication/slices/message";
import dateTimeReducer from './authentication/slices/dateTimeSlice'

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const reducer = combineReducers({
  auth: authReducer,
  message: messageReducer,
  dateTime: dateTimeReducer, 
});

const persistedReducer = persistReducer(persistConfig, reducer);

export const updateRouteList = (newRouteList) => ({
  type: 'UPDATE_ROUTE_LIST',
  payload: newRouteList,
});


const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: true,
});

const persistor = persistStore(store);

export { store, persistor };
